// Form values -> API payload (medication rows are dropped when the ration is not medicated)
export const serializeFeedRation = ({ name, medicated, medications = [] }) => ({
  name: (name || '').trim(),
  medicated: Boolean(medicated),
  medications: medicated
    ? medications
      .filter((row) => row?.treatment_product?.value)
      .map((row) => ({ treatment_product_id: row.treatment_product.value }))
    : [],
});

// API ration -> redux-form values; withdrawal figures ride along on the option item for the live boxes
export const feedRationToFormValues = ({ name, medicated, medications = [] }) => ({
  name,
  medicated,
  medications: medications.map((medication) => ({
    treatment_product: {
      value: medication.treatment_product_id,
      label: medication.treatment_product.name,
      item: {
        ...medication.treatment_product,
        withdrawal_value_us: medication.withdrawal_value_us,
        withdrawal_period_us: medication.withdrawal_period_us,
        withdrawal_value_export: medication.withdrawal_value_export,
        withdrawal_period_export: medication.withdrawal_period_export,
      },
    },
  })),
});

export const reorder = (list, fromIndex, toIndex) => {
  const result = [...list];
  const [moved] = result.splice(fromIndex, 1);
  result.splice(toIndex, 0, moved);
  return result;
};
